module.exports = __webpack_public_path__ + "img/1024.614fb41f.svg";